import { Component, OnInit } from '@angular/core';
import { NgForm, FormsModule } from '@angular/forms';
import { Inspection } from 'src/app/model/inspection.model';
import { InspectionService } from 'src/app/services/inspection/inspection.service';
import { inspect } from 'util';
import { Router, ActivatedRoute } from '@angular/router';
//import { from } from 'rxjs';

@Component({
  selector: 'app-inspectioncall',
  templateUrl: './inspectioncall.component.html',
  styleUrls: ['./inspectioncall.component.css']
})
export class InspectioncallComponent implements OnInit {
  //user : User;
  vModelData :Inspection;
  data:any;
  //vModelData : any;
  constructor( private inspectionservice :InspectionService, router:Router,
    route:ActivatedRoute) { 
    this.vModelData=new Inspection();
  }

  ngOnInit() {
    
    //this.userServices.currentUser.subscribe(
      //  (data :any) => {
       //    this.user = data;
        //  console.log(this.user);
   //     }
     //  )
  }

  submitinspectioncallForm(form : NgForm)
  {
    console.log(form.value);
    this.inspectionservice.Smtinspectioncall(form.value).subscribe(
      (data)=>{
        this.data=data;
        console.log(data);

      }
    )
  }

}
